<template>
  <Popup ref="popup" minHeight="100%" :title="title">
    <Content :top="50" :bottom="76">
      <div class="popup-content">
        <van-form ref="form" @submit="onSubmit">
          <van-field
            v-model="name"
            name="name"
            label="名称"
            placeholder="名称"
            :rules="[{ required: true, message: '请填写名称' }]"
          />
          <van-field
            v-model="seq"
            name="seq"
            label="排序"
            placeholder="排序"
            :border="false"
            :rules="[{ required: true, message: '请填写排序' }]"
          />
          <van-field
            v-model="numPlates"
            name="numPlates"
            label="车牌号码"
            placeholder="车牌号码"
            :rules="[{ required: true, message: '车牌号码' }]"
          />
          <!-- 人员列表 -->
          <template v-if="showPersonnel">
            <ul class="personnel-container">
              <li class="personnel-list-item personnel-list-title">
                <div class="personnel-list-item__name">姓名</div>
                <div class="personnel-list-item__phone">电话</div>
                <div class="personnel-list-item__del"></div>
              </li>
              <li
                v-for="item in personnelList"
                :key="item"
                class="personnel-list-item van-hairline--bottom"
              >
                <div class="personnel-list-item__name">
                  <van-field v-model="item.name" placeholder="姓名" readonly />
                </div>
                <div class="personnel-list-item__phone">
                  <van-field v-model="item.tel" placeholder="电话" readonly />
                </div>
                <div class="personnel-list-item__del">
                  <van-button
                    size="mini"
                    type="primary"
                    @click="handleDetailClick(item)"
                    >详细</van-button
                  >
                  <van-button
                    type="danger"
                    size="mini"
                    @click="handleDelPersonnelClick(item.id)"
                    >删除</van-button
                  >
                </div>
              </li>
              <!-- 列表为空 -->
              <li v-if="!personnelList.length">
                <van-empty
                  class="custom-image"
                  :image-size="50"
                  image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
                  description="空空如也"
                />
              </li>
            </ul>
            <div class="btn-container">
              <van-button
                block
                type="primary"
                plain
                size="small"
                native-type="button"
                @click="handleAddPersonnelClick"
              >
                继续添加人员
              </van-button>
            </div>
          </template>
        </van-form>
      </div>
    </Content>
    <div class="btn-fixed">
      <van-button
        block
        type="primary"
        :loading="loading"
        loading-text="请稍后..."
        :disabled="loading"
        native-type="button"
        @click="handleSubmitClick"
      >
        确认提交
      </van-button>
    </div>
  </Popup>
  <!-- 添加人员 -->
  <add-personnel
    ref="addPersonnel"
    :salePerson="true"
    @submit-values="
      (values) =>
        handleAddPersonnelSubmit({
          ...values,
          departId,
          companyId,
          roleId: '5'
        })
    "
  />
  <!-- 详细 -->
  <Popup ref="popupDetail" minHeight="100%" title="人员详细">
    <Content :top="50" :bottom="0">
      <van-cell-group>
        <van-cell title="姓名" :value="detail.name" />
        <van-cell title="电话" :value="detail.tel" />
        <van-cell title="驾驶证号" :value="detail.bemployeeAddInfo.driverLic" />
        <van-cell title="驾驶证有效期" :value="detail.bemployeeAddInfo.driverLicExp" />
        <van-cell title="危险货物准驾证号" :value="detail.bemployeeAddInfo.wxhwLic" />
        <van-cell title="危险货物准驾证有效期" :value="detail.bemployeeAddInfo.wxhwLicExp" />
        <van-cell title="押运证号" :value="detail.bemployeeAddInfo.yyLic" />
        <van-cell title="押运证有效期" :value="detail.bemployeeAddInfo.yyLicExp" />
      </van-cell-group>
    </Content>
  </Popup>
</template>

<script>
import { addCompanyEmp, getGroupInfo, delCompanyAdmin } from '@/api/chome'
import { useAddPersonnel } from '@/hooks/useAddPersonnel'
import { useDelPersonnel } from '@/hooks/useDelPersonnel'
import { ref, reactive, toRefs, computed } from 'vue'
import { useGetData } from '@/hooks/useGetData'

export default {
  name: 'AddEditSalesGroup', // 添加编辑销售组
  props: {
    title: {
      type: String
    },
    departId: {
      type: String
    },
    companyId: {
      type: String
    }
  },
  emits: ['submit-values'],
  setup(props, { emit }) {
    // popup
    const popup = ref(null)
    const showPopup = () => {
      popup.value.show = true
      state.groupChecked = []
      state.name = ''
      state.seq = ''
      state.numPlates = ''
    }
    const hidePopup = () => {
      popup.value.show = false
    }

    // form Data
    const state = reactive({
      name: '',
      seq: '',
      numPlates: ''
    })

    // 获取人员列表
    const showPersonnel = computed(() => {
      const res = props.title === '编辑销售组'
      return res
    })
    const personnelList = ref([])
    const getPersonnelList = useGetData(getGroupInfo, (data) => {
      const { empList } = data
      personnelList.value = empList
    })

    // 添加人员
    const { addPersonnel, handleAddPersonnelClick, handleAddPersonnelSubmit } =
      useAddPersonnel(addCompanyEmp, () => {
        getPersonnelList({ deptId: props.departId })
      })

    // 删除人员
    const { handleDelPersonnelClick } = useDelPersonnel(delCompanyAdmin, () => {
      // 删除成功后回调
      getPersonnelList({ deptId: props.departId })
    })

    // 提交form
    const form = ref(null)
    const handleSubmitClick = () => {
      form.value.submit()
    }
    const loading = ref(false)
    const onSubmit = (values) => {
      emit('submit-values', values)
    }
    // 详细
    const popupDetail = ref(null)
    const detail = ref({})
    const handleDetailClick = (item) => {
      console.log(item)
      detail.value = item
      popupDetail.value.showPopup()
    }
    return {
      popup,
      showPopup,
      hidePopup,
      onSubmit,
      loading,
      ...toRefs(state),
      state,
      personnelList,
      addPersonnel,
      handleAddPersonnelSubmit,
      handleAddPersonnelClick,
      handleSubmitClick,
      form,
      showPersonnel,
      handleDelPersonnelClick,
      handleDetailClick,
      popupDetail,
      detail
    }
  }
}
</script>

<style lang="scss" scoped>
.personnel-container {
  background-color: #fff;
  font-size: 14px;
  .personnel-list-title {
    padding: 16px;
    background-color: #f8f8f8;
    &__name,
    &__phone {
      flex: 1;
    }
    &__del {
      width: 80px;
    }
  }
  .personnel-list-item {
    display: flex;
    align-items: center;
    &__name,
    &__phone {
      flex: 1;
    }
    &__del {
      margin-right: 16px;
    }
  }
}
.btn-container {
  margin: 16px;
}
.btn-fixed {
  margin: 16px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
